<template>
  <div class="users">
    <h2 class="text__center">Users</h2>
    <UserFilters />
    <div class="users--actions flex__right">
      <button class="btn btn__small btn__green users--new" @click="setNewToggled">New User</button>
    </div>
    <NewUser :toggled="newToggled" @setNewToggled="setNewToggled" />
    <DeleteUser
      :toggled="deleteToggled"
      :user="deleteUser"
      @toggleDelete="setDeleteToggled"
      @clearDeleteUser="clearDeleteUser"
    />
    <div class="tile-group">
      <User
        v-for="user in trimmedUsers"
        :key="user._id"
        :user="user"
        @toggleDelete="setDeleteToggled"
      />
    </div>
    <p v-if="!allShown" class="content__heading pointer" @click="showMore">Show More</p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserFilters from "./UserFilters";
import User from "./User";
import NewUser from "./NewUser";
import DeleteUser from "./DeleteUser";
export default {
  data() {
    return {
      newToggled: false,
      deleteToggled: false,
      deleteUser: null,
      showing: 12
    };
  },
  components: {
    UserFilters,
    User,
    NewUser,
    DeleteUser
  },
  computed: {
    ...mapGetters(["getFilteredUsers"]),
    trimmedUsers() {
      return this.getFilteredUsers.slice(0, this.showing);
    },
    allShown() {
      if (this.showing >= this.getFilteredUsers.length) {
        return true;
      }
      return false;
    }
  },
  methods: {
    showMore() {
      this.showing += 12;
    },
    setNewToggled() {
      return (this.newToggled = !this.newToggled);
    },
    setDeleteToggled(user) {
      this.deleteUser = user;
      return (this.deleteToggled = !this.deleteToggled);
    },
    clearDeleteUser() {
      this.deleteUser = null;
      this.deleteToggled = !this.deleteToggled;
    }
  }
};
</script>

<style scoped lang="scss">
@media (min-width: $xxl) {
  .tile-group {
    @include tile-group($col-num: 3);
  }
}
</style>